<template>
  <div>
    <v-row density="compact" class="mb-2" align="center">
      <v-col cols="auto">
        <v-btn-toggle v-model="direction" mandatory density="compact" color="primary">
          <v-btn value="buys">New Buys / Increases</v-btn>
          <v-btn value="sells">Sells / Decreases</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="excludeUs"
          label="Exclude US stocks"
          density="compact"
          hide-details
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="25"
      density="compact"
      :no-data-text="loading ? 'Loading...' : 'No data available.'"
    >
      <template #item.instrument_name="{ item }">
        <template v-if="item.instrument_name">
          <router-link v-if="item.perm_id_instrument_id" :to="'/global/instrument/' + item.perm_id_instrument_id">
            {{ item.instrument_name }}
          </router-link>
          <span v-else>{{ item.instrument_name }}</span>
        </template>
        <span v-else class="text-grey font-italic">
          <v-icon size="x-small" class="mr-1">mdi-lock</v-icon>Standard subscription required
        </span>
      </template>
      <template #item.total_change_value="{ item }">
        <span :class="item.total_change_value > 0 ? 'text-green' : 'text-red'">
          ${{ human_number(item.total_change_value) }}
        </span>
      </template>
      <template #item.total_portfolio_value="{ item }">
        ${{ human_number(item.total_portfolio_value) }}
      </template>
      <template #item.avg_pct_portfolio="{ item }">
        {{ percent(item.avg_pct_portfolio) }}
      </template>
    </v-data-table>
    <v-alert v-if="!isSubscriber && items.length > 0" type="info" variant="tonal" class="mt-3">
      Showing 2 of {{ items.length }} results.
      <a href="/pricing" target="_blank">Subscribe</a> to view all trending positions.
    </v-alert>
    <small>Source: Refinitiv</small>
  </div>
</template>

<script>
import api from '@/store/api'
import { useAppStore, useUserStore } from '@/store'
import FormattersMixin from '@/mixins/formatters'

export default {
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      direction: 'buys',
      excludeUs: false,
      items: [],
      headers: [
        { title: 'Stock Name', key: 'instrument_name' },
        { title: 'Ticker', key: 'ticker' },
        { title: 'Country', key: 'issuer_country' },
        { title: 'Net Change in Value', key: 'total_change_value' },
        { title: 'Total Market Value', key: 'total_portfolio_value' },
        { title: '# Funds', key: 'num_funds' },
        { title: 'Avg % Portfolio', key: 'avg_pct_portfolio' }
      ]
    }
  },

  computed: {
    isSubscriber() {
      const store = useUserStore()
      return store.isSubscriber || store.isProSubscriber || store.isEnterpriseSubscriber
    }
  },

  watch: {
    direction() { this.fetchData() },
    excludeUs() { this.fetchData() }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      const params = { direction: this.direction }
      if (this.excludeUs) params.exclude_us = 'true'
      api.get('global_trending_positions', { params })
        .then(response => { this.items = response.data })
        .catch(error => {
          useAppStore().showNotification({ type: 'error', text: (error.response?.data) || error.message })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
